import { useContext } from 'react';
import PropTypes from 'prop-types';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { isInvalidQuestionsCanonical } from './rules/question-redirect-rules';
import { handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';
import { isNotFound, isInvalidItemId } from './rules/pip-redirect-rules';

const questionsHandler = ({ data, error, props }) => {
  const { itemId, bypass, pathWithQueryParams } = props;
  const [path, queryParams] = pathWithQueryParams?.split('?') || '';

  const invalidItemId = isInvalidItemId({ itemId });
  if (invalidItemId) {
    return new RedirectTag(invalidItemId, bypass);
  }

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.PRODUCT);
  if (errors) {
    return new RedirectTag(errors, bypass);
  }

  const notFound = isNotFound({ data, itemId });
  if (notFound) {
    return new RedirectTag(notFound, bypass);
  }

  const checkQuestionsCanonical = isInvalidQuestionsCanonical({ data, path });
  if (checkQuestionsCanonical) {
    return new RedirectTag(checkQuestionsCanonical, bypass);
  }

  return null;
};

export const QuestionsRedirector = ({ itemId }) => {
  const { pathWithQueryParams, bypass } = useContext(RedirectContext);

  const opts = {
    variables: {
      itemId
    }
  };

  const props = {
    itemId,
    bypass,
    pathWithQueryParams
  };

  const { data, error } = useDataModel('product', opts);
  useHelmet('questionsRedirector', { props, data, error }, questionsHandler, [itemId, data, error]);

  return null;
};

QuestionsRedirector.displayName = 'QuestionsRedirector';

QuestionsRedirector.propTypes = {
  itemId: PropTypes.string.isRequired
};

QuestionsRedirector.defaultProps = {};

QuestionsRedirector.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
